<template>
  <App>
    <div class="d-flex flex-column flex-xl-row">
      <!--begin::Sidebar-->
      <div class="flex-column flex-lg-row-auto w-450px mb-10">
        <!--begin::Card-->
        <div class="card mb-5 mb-xl-8">
          <!--begin::Card body-->
          <div class="card-body">
            <div id="kt_customer_view_details" class="collapse show">
              <div class="fs-6" v-if="avaliacao.avaliacao_resumo.file">
                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                  <div class="d-flex align-items-center">
                  <span class="svg-icon svg-icon-3 svg-icon-success me-2 text-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                  </span>
                    <div class="fs-2 fw-bold"> Correções do Avaliador</div>
                  </div>
                  <div class="fw-semobold fs-6 text-gray-400">Clique <a :href="route('app.projetos.download-resumo-avaliador', avaliacao.id)" target="_blank">aqui</a> para fazer download.</div>
                </div>
              </div>

              <div class="fs-6 mt-5">
                <div class="fw-bolder mt-5">Observações do(a) Avaliador(a)</div>
                <div class="text-gray-600 mt-5" v-html="avaliacao.avaliacao_resumo.observacoes?.replaceAll('\n', '</br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Sidebar-->
      <!--begin::Content-->
      <div class="flex-lg-row-fluid ms-lg-15">
        <form-body :loading="form.processing" :form="form" hideSubmitButton>
          <div class="col-4">
            <form-group label="Resumo Corrigido" :is-invalid="form.errors.resumo">
              <input
                class="form-control"
                @input="form.resumo = $event.target.files[0]"
                type="file"
                placeholder="Resumo Corrigido"
                accept=".doc,.docx,application/msword"
                @blur="form.clearErrors('resumo')"
                :class="{'is-invalid' : form.errors.resumo}"
              />
            </form-group>
          </div>

          <button @click="enviarCorrecao" v-if="avaliacao.situacao === 1 || avaliacao.situacao === 5" class="btn btn-success mt-3">
            Enviar
          </button>
        </form-body>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";

export default {
  props: ['avaliacao'],

  components: {
    FormGroup,
    FormBody,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  setup(props) {
    const form = useForm({
      id: props.avaliacao.projeto.id,
      resumo: null
    })
    return {form};
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Corrige Projeto');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Projetos', link: 'app.projetos.index'},
        {title: 'Corrige Projeto'},
      ]);

      this.emitter.emit('action', {
            show: true,
            icon: 'bi-arrow-left-short',
            title: 'Voltar',
            link: this.route('app.projetos.index')
          }
      );
    },

    enviarCorrecao() {
      this.emitter.emit('alert', {
        title: 'Confirma a ação?',
        text: 'Tem certeza que deseja enviar suas correções?',
        icon: 'warning',
        success: this.envia
      })
    },

    envia() {
      this.form.processing = true
      this.form.post(this.route('app.projetos.corrige-projeto-update', {'id': this.form.id}))
    },

    caracteresRestantes(limit, input) {
      var char = this.form[input]?.length;
      let count = char ? (limit - char) : limit
      return count + " caracteres restantes de " + limit;
    }
  },
};
</script>
